import { AssessmentService } from './AssessmentService';

/**
 * TeacherService: Manages teacher dashboard analytics and metrics
 * with safe content-type verification and robust local fallback handling.
 */
export const TeacherService = {
  async getTeacherDashboard(accessToken) {
    try {
      const response = await fetch('/.netlify/functions/teacher-dashboard', {
        method: 'GET',
        cache: 'no-store',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        }
      });

      const contentType = response.headers.get('content-type') || '';
      if (!response.ok || !contentType.includes('application/json')) {
        return {
          success: true,
          dashboard: AssessmentService.getClassAnalytics()
        };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: true,
        dashboard: AssessmentService.getClassAnalytics()
      };
    }
  }
};

export default TeacherService;